import ajax from './ajax/index'
import { modalPlugin } from './modal'
import { drawerPlugin } from './drawer'
import { elDrawerPlugin } from './el-drawer'
import { elDialogPlugin } from './el-dialog'
import ViewUIPlus from 'view-ui-plus'
import BiliDesign from '@bilibili-business/bili-design'

import 'dayjs/locale/zh-cn'
import zhCn from '@bilibili-business/bili-design/es/locale/lang/zh-cn'

export const usePlugin = app => {
  app.use(ViewUIPlus)
  app.use(BiliDesign, {
    locale: zhCn
  })
  app.use(modalPlugin)
  app.use(elDialogPlugin)
  app.use(drawerPlugin)
  app.use(elDrawerPlugin)
  app.use(ajax)
}
